'use client'

import { useCallback } from 'react'

import { useRouter } from '@/i18n-routing'

interface UseGoBackOptions {
	fallbackPath?: string
}

export const useGoBack = (options: UseGoBackOptions = {}) => {
	const { fallbackPath = '/' } = options
	const router = useRouter()

	return useCallback(() => {
		if (window.history.length > 1) {
			router.back()
		} else {
			router.push(fallbackPath)
		}
	}, [router, fallbackPath])
}
